@if (nextStepForm) {
  <form [formGroup]="nextStepForm" class="flex max-sm:flex-col">
    <div
      class="form-input flex-1 mr-2"
      [ngClass]="{
        'has-error': nextStepForm.controls['description'].errors && nextStepForm.controls['description'].touched,
      }"
    >
      @if (!(nextStepForm.controls['description'].errors && nextStepForm.controls['description'].touched)) {
        <label class="flex items-center gap-2">
          <ion-icon name="flag-outline"></ion-icon>
          Next Step
        </label>
      } @else {
        <label id="next-step-description-error">
          <ion-icon name="alert-circle" class="text-base"></ion-icon>
          @if (nextStepForm.controls['description'].errors?.['required']) {
            <div id="required" class="error">Next Step is required</div>
          }
          @if (nextStepForm.controls['description'].errors?.['minlength']) {
            <div id="min-length" class="error">Next step is too short</div>
          }
        </label>
      }
      <input
        id="next-step-description"
        name="description"
        type="text"
        autocomplete="off"
        formControlName="description"
        placeholder="What needs to happen next?"
        class="form-control text-sm"
        aria-labelledby="next-step-description-error"
        [attr.aria-invalid]="
          nextStepForm.controls['description'].errors && nextStepForm.controls['description'].touched
        "
      />
    </div>
    <div
      class="form-input bp-0"
      [ngClass]="{
        'has-error': nextStepForm.controls['due_date'].errors && nextStepForm.controls['due_date'].touched,
      }"
    >
      @if (!(nextStepForm.controls['due_date'].errors && nextStepForm.controls['due_date'].touched)) {
        <label for="next-step-due-date"> Due Date </label>
      } @else {
        <label id="next-step-due-date-error">
          <ion-icon name="alert-circle" class="text-base"></ion-icon>
          @if (nextStepForm.controls['due_date'].errors?.['required']) {
            <div id="required" class="error">Due Date is required</div>
          }
        </label>
      }
      <app-date-picker
        id="next-step-due-date"
        datePickerId="next-step-due-date"
        class="text-sm"
        [date]="nextStepForm.controls['due_date'].value"
        [minDate]="today"
        (selectedDates)="nextStepForm.patchValue({ due_date: $event.date })"
      ></app-date-picker>
    </div>
  </form>
}
